@let inventory = inventoryItem();

<div class="inventory-items-container">
  <ul>
    @for (column of columns; track column.key) {
      <li [class.actions-column]="column.key === inventoryColumnKey.ACTIONS">
        @if (column.key === inventoryColumnKey.PRODUCT_UPC_AND_NAME) {
          <span class="inventory-item-no">{{ inventory.productUpc }}</span>
          <span class="inventory-item-name">{{ inventory.productName }}</span>
        } @else if (column.key === inventoryColumnKey.PRICE) {
          <span>{{ inventory.price | currency }}</span>
        } @else if (column.key === inventoryColumnKey.STATUS) {
          <div class="status-container">
            <span class="status" [ngClass]="inventory.status.toLowerCase()">
              {{ inventory.status }}
            </span>
          </div>
        } @else if (column.key === inventoryColumnKey.LAST_UPDATED_DATE) {
          <span>
            {{ inventory.lastUpdatedDate | date: 'dd/MM/yyyy' }}
          </span>
        } @else if (column.key === inventoryColumnKey.ACTIONS) {
          <button mat-icon-button [matMenuTriggerFor]="actionsMenu" class="menu-trigger">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #actionsMenu="matMenu">
            <button mat-menu-item (click)="onOpenModal()" class="actions-view">
              <span class="menu-item-content">
                <app-icon class="icon-customer" [icon]="iconName.VIEW_ORDER" />
                <span class="menu-item-text">
                  {{ 'inventory.actions.viewItem' | translate }}
                </span>
              </span>
            </button>

            <button mat-menu-item (click)="onOpenEditModal()" class="actions-edit">
              <span class="menu-item-content">
                <app-icon class="icon-customer" [icon]="iconName.PENCIL" />
                <span class="menu-item-text">
                  {{ 'inventory.actions.editItem' | translate }}
                </span>
              </span>
            </button>
          </mat-menu>
        } @else {
          {{ getColumnValue(inventory, column.key) }}
        }
      </li>
    }
  </ul>
</div>
